import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";

// Services
import { vehicleService } from "../../Services/vehicle.service";
import { toDateTime } from "../../Services/string.service";

// Icons
import { IoIosCar } from "react-icons/io";
import { IoMdCar } from "react-icons/io";

// Constants
const _pageTitle = "Detalhes de Indicadores";
const _listTitle = "Operacionais";

export default function OperationalDetails() {

    const dispatch = useDispatch();
    dispatch({ type: "title", value: _pageTitle });

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchIndicators = async () => {
        console.log('🐗: fetchIndicators');

        setLoading(true);

        try {

            var result = await vehicleService.fetchVehicleOperationalIndicatorDetails();

            console.log("Resultado fetchVehicleOperationalIndicatorDetails:");
            console.log(result?.report);

            if (result?.report)
                setData(result?.report);

        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        (async () => {
            await fetchIndicators();
        })();
    }, []);


    return (
        <>
            <div className='container-xxl flex-grow-1 container-p-y'>

                {loading ? <Spinner /> : ""}


                <div style={loading ? { display: "none" } : { display: "" }} className="col-md-6 col-lg-4 order-2 mb-4">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="card-title m-0 me-2"><IoIosCar size={25} /> {_listTitle}</h5>
                        </div>
                        <div className="card-body">
                            <ul className="p-0 m-0">


                                {data.map((item, index) => (

                                    <li className="d-flex mb-4 pb-1" key={index}>
                                        <div className="avatar flex-shrink-0 me-3">
                                            <IoMdCar size={23} />
                                        </div>
                                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                            <div className="me-2">
                                                <h6 className="mb-0">{item.licensePlate}</h6>
                                            </div>
                                            <div className="user-progress d-flex align-items-center gap-1">
                                                {/* <h6 className="mb-0">+82.6</h6>  */}
                                                <span className="text-muted">{toDateTime(item.lastRecordTime)}</span>
                                            </div>
                                        </div>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};